import { render } from "./myInq.vue?vue&type=template&id=3181438a&scoped=true"
import script from "./myInq.vue?vue&type=script&lang=js"
export * from "./myInq.vue?vue&type=script&lang=js"

import "./myInq.vue?vue&type=style&index=0&id=3181438a&lang=scss"
import "./myInq.vue?vue&type=style&index=1&id=3181438a&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181438a"]])

export default __exports__